import { render, staticRenderFns } from "./AddUserButton.vue?vue&type=template&id=1ba9b5fc&"
import script from "./AddUserButton.vue?vue&type=script&lang=js&"
export * from "./AddUserButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports